import React, { useEffect, useState } from "react";
import { Box, Typography, Paper, Divider, Grid, Checkbox, FormControlLabel, Radio, RadioGroup, FormControl, FormLabel } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";

import { setCompleteTaskButtonEnabled, setReferbackTaskButtonEnabled } from "store/slice/AppSlice";
import ShowProformaInvoice from "components/product/components/price-calculation/ShowProformaInvoice";
import FieldView2 from "core/components/layout/FieldView2";
import CommentMgmt from "../comment/CommentMgmt";
import EditIcon from '@mui/icons-material/Edit';
import { setProductUpdateproductModal } from "store/slice/PharmaSlice";
import { setSelectedProductId } from "store/slice/PharmaSlice";
import UpdateproductActionModal from "components/product/action/updateproduct/UpdateproductActionModal";
import { updateProductInfo } from "components/product/ProductAPI";
import { updateProductObj } from "store/slice/PharmaSlice";

export default function TaskSpaceSalesRevisePoForQAFeedback() {
  const dispatch = useDispatch();
  const [pmorderList, setPmorderList] = React.useState([]);
  const [pmorderObj, setPmorderObj] = React.useState({});
  const [confirmed, setConfirmed] = useState(false);
  const { productObj } = useSelector((state) => state.pharmaslice.productDashboard);
  const {productList} = useSelector((state) => state.pharmaslice);
  const { taskApiResponse, taskCompleted } = useSelector((state) => state.appslice.wkflow);
  const { commentList } = useSelector(state => state.appslice.wkflow);
  const [localProductList, setLocalProductList] = useState([]);
  const {pharmaorderObj} = useSelector((state) => state.pharmaslice.pharmaorderDashboard);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [editProductObj, setEditProductObj] = useState(null);
  const [editMRP, setEditMRP] = useState("");
  const [saving, setSaving] = useState(false);
  const [apiError, setApiError] = useState("");

  useEffect(() => {
    dispatch(setCompleteTaskButtonEnabled(true));
    setLocalProductList(productList.filter(product => product.orderid === pharmaorderObj.id && (
      product.statusname!=='CANCELLED' && product.overallstatusid!==10)));
  }, []);
  useEffect(() => {
   if (commentList && commentList.length > 0) {
      dispatch(setReferbackTaskButtonEnabled(true));
    }
  }, [commentList]);
  useEffect(() => {
    
  }, [productObj]);

  
  const editProduct = (product) => {
    //dispatch(setSelectedProductId(product.id));
    dispatch(setProductUpdateproductModal(true));
  };

  const handleEditClick = (product) => {
    setEditProductObj(product);
    setEditMRP(product.mrptext || "");
    setEditDialogOpen(true);
  };

  const handleSaveMRP =  () => {
      setApiError("");
      updateProductInfo(
        editProductObj.id,
        { mrptext: editMRP },
        (response) => {  
          dispatch(updateProductObj(response));
          setEditDialogOpen(false);
        },
        (error) => {
          setApiError(error || "Error updating product MRP");
          console.error("Error updating product MRP:", error);
        }
      );
  };

  return (
    <Grid item lg={12} md={12} sm={12} xs={12} >
          <Grid container sx={{ width: '100%' }}>
            <Grid item lg={8} md={4} sm={4} xs={12}>
              <ShowProformaInvoice  />
            </Grid>
            <Grid item lg={4} md={8} sm={8} xs={12} sx={{ pl: 2 }}>
              <Grid container sx={{ width: '100%', }}>
                <Grid item lg={12} md={12} sm={12} xs={12} sx={{  borderRadius: 2,mb:2}}>
                  <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>Product(s)</Typography>
                  <Grid container direction="row" sx={{ width: '100%', }}>
                    {localProductList.map((product, index) => (
                      <Grid item lg={6} md={12} sm={12} xs={12} key={index} sx={{ }}>
                        <Box sx={{  backgroundColor: productObj.id===product.id?'primary.darker':'white', color:productObj.id===product.id?'white':'', borderRadius: 2,p:1, cursor:'pointer' }} onClick={() => dispatch(setSelectedProductId(product.id))}>
                          <Typography variant="h5" sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            {product.brandname}
                            <Box sx={{ ml: 1, display: 'flex', alignItems: 'center' }}>
                              <EditIcon onClick={e => { e.stopPropagation(); handleEditClick(product); }} sx={{ cursor: "pointer" }} />
                            </Box>
                          </Typography> 
                          <Typography variant="h6" color="primary">{product.title}</Typography> 
                        </Box>
                      </Grid>
                    ))}
                   
                  </Grid>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12} sx={{  borderRadius: 2,}}>
                  <Box sx={{width:'100%', backgroundColor: "white", borderRadius: 2, p: 1 }}>
                    <CommentMgmt maxHeight='50vh'/>
                  </Box>                 
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <UpdateproductActionModal/>

          {/* Edit MRP Dialog */}
          <Dialog open={editDialogOpen} onClose={() => setEditDialogOpen(false)} maxWidth="xs" fullWidth>
            <DialogTitle>Edit MRP</DialogTitle>
            <DialogContent>
              <TextField
                label="MRP"
                type="number"
                value={editMRP}
                onChange={e => setEditMRP(e.target.value)}
                fullWidth
                autoFocus
                sx={{ mt: 2 }}
              />
            </DialogContent>
            <DialogActions>
              {apiError && (
                <Typography color="error" sx={{ mr: 2, flexGrow: 1 }}>
                  {apiError}
                </Typography>
              )}
              <Button onClick={() => setEditDialogOpen(false)} color="secondary">
                Cancel
              </Button>
              <Button onClick={handleSaveMRP} color="primary" variant="contained" disabled={saving}>
                Save
              </Button>
            </DialogActions>
          </Dialog>
        </Grid>
          
    
  );
}